import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import BankTable from "../../../components/Content/ItemTableBank";

import {
  deleteData,
  getAlert,
  getDataWithJoin,
  insertData,
  updateData,
  getData,
} from "../../../../utils/SamuiUtils";
import { useNavigate } from "react-router-dom";
import CurrencyInput from "react-currency-input-field";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataAPtype,
}) => {
  const [initialFormData, setInitialFormData] = useState({});
  const [bankList, setBankList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        comp_id: window.localStorage.getItem("company"),
        ap_code: "",
        ap_name: "",
        ap_type: "",
        ap_shortname: "",
        ap_taxno: "",
        ap_add1: "",
        ap_add2: "",
        ap_add3: "",
        ap_province: "",
        ap_zipcode: "",
        ap_contact: "",
        ap_contact2: "",
        ap_tel: "",
        ap_tel2: "",
        ap_group: "",
        ap_refsalecode: "",
        ap_area: "",
        ap_status: "Y",
        ap_credit: 0,
        ap_vat: 0,
        ap_discount: 0.0,
        ap_branch: "",
        ap_bt_name: "",
        ap_type_s: "M",
        ap_email: "",
        ap_email2: "",
        ap_fb_email: "",
        ap_fb_telephone: "",
      };
      // กำหนดค่าเริ่มต้นให้กับ form data
      setFormData(initialData);
      // กำหนดค่าเริ่มต้นให้กับ initial form data
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        ap_id: selectedData.AP_Id, // Int
        comp_id: window.localStorage.getItem("company"), // Int
        ap_code: selectedData.AP_Code,
        ap_name: selectedData.AP_Name,
        ap_type: selectedData.AP_Type, // Int
        ap_shortname: selectedData.AP_ShortName,
        ap_taxno: selectedData.AP_TaxNo,
        ap_add1: selectedData.AP_Add1,
        ap_add2: selectedData.AP_Add2,
        ap_add3: selectedData.AP_Add3,
        ap_province: selectedData.AP_Province,
        ap_zipcode: selectedData.AP_Zipcode,
        ap_contact: selectedData.AP_Contact,
        ap_contact2: selectedData.AP_Contact2,
        ap_tel: selectedData.AP_Tel,
        ap_tel2: selectedData.AP_Tel2,
        ap_group: selectedData.AP_Group,
        ap_refsalecode: selectedData.AP_RefSaleCode,
        ap_area: selectedData.AP_Area,
        ap_status: selectedData.AP_Status,
        ap_credit: parseInt(selectedData.AP_Credit, 10), // Int
        ap_vat: parseInt(selectedData.AP_Vat, 10), // Int
        ap_discount: selectedData.AP_Discount,
        ap_branch: selectedData.AP_Branch,
        ap_bt_name: selectedData.AP_BT_Name,
        ap_type_s: selectedData.AP_Type_S,
        ap_email: selectedData.AP_Email,
        ap_email2: selectedData.AP_Email2,
        ap_fb_email: selectedData.AP_FB_Email || "",
        ap_fb_telephone: selectedData.AP_FB_Telephone || "",
      };
      // อัปเดตค่าให้กับ form data
      setFormData(initialData);
      // อัปเดตค่าให้กับ initial form data
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const loadBankList = async (ap_id) => {
    const res = await getData("Tb_Set_AP_Account", `ap_id = ${ap_id}`);
    if (res.length > 0) {
      const mapped = res.map((item) => ({
        bank_name: item.bank_name,
        bank_acc_no: item.bank_acc_no,
        bank_acc_name: item.bank_acc_name,
        bank_default: item.bank_default,
      }));
      setBankList(mapped);
    }
  };

  useEffect(() => {
    if (mode === "U" && selectedData.AP_Id) {
      loadBankList(selectedData.AP_Id);
    }
  }, [mode, selectedData]);

  // ฟังก์ชันที่ใช้ในการเปลี่ยนค่าของข้อมูลในฟอร์ม
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "ap_taxno") {
      if (/^\d*$/.test(value) && value.length <= 13) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "ap_zipcode") {
      if (value.length <= 5) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "ap_group") {
      if (/^\d*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const handleCurrencyChange = (value, name) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertAP = async () => {
    try {
      const { ap_id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_AP", fields, values);

      const insertedAPId = parseInt(
        res.result?.recordsets?.[0]?.[0]?.insertedId
      );

      if (res?.status === "OK" && insertedAPId) {
        // 🔁 Insert bank accounts (Tb_Set_AP_Account)
        for (const bank of bankList) {
          const bankFields = [
            "ap_id",
            "bank_name",
            "bank_acc_no",
            "bank_acc_name",
            "bank_default",
          ];
          const bankValues = [
            insertedAPId,
            bank.bank_name || "",
            bank.bank_acc_no || "",
            bank.bank_acc_name || "",
            bank.bank_default || "N",
          ];

          await insertData(
            "Tb_Set_AP_Account",
            bankFields.join(", "),
            bankValues
          );
        }

        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error in handleInsertAP:", error);
      getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลได้");
    }
  };

  const formatValues = (data) => {
    const allowedFields = [
      "comp_id",
      "ap_code",
      "ap_name",
      "ap_type",
      "ap_shortname",
      "ap_taxno",
      "ap_add1",
      "ap_add2",
      "ap_add3",
      "ap_province",
      "ap_zipcode",
      "ap_contact",
      "ap_contact2",
      "ap_tel",
      "ap_tel2",
      "ap_group",
      "ap_refsalecode",
      "ap_area",
      "ap_status",
      "ap_credit",
      "ap_vat",
      "ap_discount",
      "ap_branch",
      "ap_bt_name",
      "ap_type_s",
      "ap_email",
      "ap_email2",
      "ap_fb_email",
      "ap_fb_telephone",
    ];

    const filtered = {};

    allowedFields.forEach((key) => {
      if (data.hasOwnProperty(key)) {
        filtered[key] = data[key];
      }
    });

    return filtered;
  };

  const handleUpdateAP = async () => {
    try {
      const where = { ap_id: formData.ap_id };
      const values = formatValues(formData);

      const res = await updateData("Tb_Set_AP", values, where);

      // 🔄 ลบ bank เดิม
      await deleteData("Tb_Set_AP_Account", `WHERE ap_id = ${formData.ap_id}`);

      // 🔁 Insert bank ใหม่
      for (const bank of bankList) {
        const bankFields = [
          "ap_id",
          "bank_name",
          "bank_acc_no",
          "bank_acc_name",
          "bank_default",
        ];
        const bankValues = [
          formData.ap_id,
          bank.bank_name || "",
          bank.bank_acc_no || "",
          bank.bank_acc_name || "",
          bank.bank_default || "N",
        ];

        await insertData(
          "Tb_Set_AP_Account",
          bankFields.join(", "),
          bankValues
        );
      }

      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      console.error("Error in handleUpdateAP:", error);
      getAlert("FAILED", "ไม่สามารถอัปเดตข้อมูลได้");
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData("Tb_Set_AP", `WHERE AP_Id = ${selectedData.AP_Id}`);
          await deleteData(
            "Tb_Set_AP_Account",
            `WHERE ap_id = ${selectedData.AP_Id}`
          );

          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();

          // reset formData หากต้องการ reset หลังลบ
          setFormData({
            ap_id: "", // Int
            comp_id: window.localStorage.getItem("company"), // Int
            ap_code: "",
            ap_name: "",
            ap_type: "", // Int
            ap_shortname: "",
            ap_taxno: "",
            ap_add1: "",
            ap_add2: "",
            ap_add3: "",
            ap_province: "",
            ap_zipcode: "",
            ap_contact: "",
            ap_contact2: "",
            ap_tel: "",
            ap_tel2: "",
            ap_group: "",
            ap_refsalecode: "",
            ap_area: "",
            ap_status: "Y",
            ap_credit: 0,
            ap_vat: 0,
            ap_discount: "",
            ap_branch: "",
            ap_bt_name: "",
            ap_type_s: "",
            ap_email: "",
            ap_email2: "",
          });
          setBankList([]);
        }
      });
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (!formData.ap_code || !formData.ap_name || !formData.ap_status) {
        console.debug("formData", formData);
        getAlert(
          "WARNING",
          "โปรดกรอกข้อมูล รหัสเจ้าหนี้ ชื่อเจ้าหนี้  ประเภทเจ้าหนี้  สถานะ"
        );
        return;
      }

      if (
        formData.ap_code === initialFormData.ap_code &&
        formData.ap_name === initialFormData.ap_name &&
        formData.ap_type === initialFormData.ap_type &&
        formData.ap_shortname === initialFormData.ap_shortname &&
        formData.ap_taxno === initialFormData.ap_taxno &&
        formData.ap_add1 === initialFormData.ap_add1 &&
        formData.ap_add2 === initialFormData.ap_add2 &&
        formData.ap_add3 === initialFormData.ap_add3 &&
        formData.ap_province === initialFormData.ap_province &&
        formData.ap_zipcode === initialFormData.ap_zipcode &&
        formData.ap_contact === initialFormData.ap_contact &&
        formData.ap_contact2 === initialFormData.ap_contact2 &&
        formData.ap_tel === initialFormData.ap_tel &&
        formData.ap_tel2 === initialFormData.ap_tel2 &&
        formData.ap_group === initialFormData.ap_group &&
        formData.ap_refsalecode === initialFormData.ap_refsalecode &&
        formData.ap_area === initialFormData.ap_area &&
        formData.ap_status === initialFormData.ap_status &&
        formData.ap_credit === initialFormData.ap_credit &&
        formData.ap_vat === initialFormData.ap_vat &&
        formData.ap_discount === initialFormData.ap_discount &&
        formData.ap_branch === initialFormData.ap_branch &&
        formData.ap_bt_name === initialFormData.ap_bt_name &&
        formData.ap_type_s === initialFormData.ap_type_s
      ) {
        getAlert(
          "WARNING",
          "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
        );
        return;
      }
      if (mode === "I") {
        await handleInsertAP();
      } else if (mode === "U") {
        await handleUpdateAP();
      }
      // await callInitialize();
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const checkApCode = async () => {
    const { item_id, ...dataToInsert } = formData;

    const resItemCode = await getDataWithJoin(
      `a.*`,
      `[dbo].[Tb_Set_AP] AS a`,
      `WHERE a.AP_Code = '${formData.ap_code}'`,
      ""
    );

    if (resItemCode && resItemCode.length > 0) {
      getAlert("FAILED", "มีรหัสเจ้าหนี้แล้ว");
      setFormData((prev) => ({ ...prev, ap_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสเจ้าหนี้นี้สามารถใช้ได้");
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/creditor" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container p-4">
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-md-4">
                <label className="">รหัสเจ้าหนี้</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_code"
                  value={formData.ap_code || ""}
                  onChange={handleChange}
                  onBlur={mode !== "U" ? checkApCode : undefined}
                />
              </div>
              <div className="col-md-4">
                <label className="">รหัสอ้างอิงการขาย</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_refsalecode"
                  value={formData.ap_refsalecode || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label className="">เลขภาษี</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_taxno"
                  value={formData.ap_taxno || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ชื่อเจ้าหนี้</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_name"
                  value={formData.ap_name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ชื่อย่อ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_shortname"
                  value={formData.ap_shortname || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ประเภทเจ้าหนี้</label>
                {/* <input
              type="number"
              className="form-control input-spacing"
              name="ap_type"
              value={formData.ap_type || ""}
              onChange={handleChange}
            /> */}
                <div class="input-group">
                  <select
                    className="form-select"
                    name="ap_type"
                    value={formData.ap_type}
                    onChange={handleChange}
                    style={{ color: "black" }}
                    disabled={dataAPtype.length <= 0}
                  >
                    {dataAPtype.map((type, index) => (
                      <option key={index} value={type.APType_Id}>
                        {type.APType_Name}
                      </option>
                    ))}
                  </select>
                  {dataAPtype.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/APtype")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ชื่อธุรกิจ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_bt_name"
                  value={formData.ap_bt_name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">สาขา</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_branch"
                  value={formData.ap_branch || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">กลุ่ม</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_group"
                  value={formData.ap_group || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ที่อยู่ 1</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_add1"
                  value={formData.ap_add1 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ที่อยู่ 2</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_add2"
                  value={formData.ap_add2 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ที่อยู่ 3</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_add3"
                  value={formData.ap_add3 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">พื้นที่</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_area"
                  value={formData.ap_area || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">จังหวัด</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_province"
                  value={formData.ap_province || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">รหัสไปรษณีย์</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_zipcode"
                  value={formData.ap_zipcode || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label className="">ติดต่อ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_contact"
                  value={formData.ap_contact || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label className="">ติดต่อ 2</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_contact2"
                  value={formData.ap_contact2 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">อีเมลล์ </label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_email"
                  value={formData.ap_email || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">อีเมลล์2</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_email2"
                  value={formData.ap_email2 || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">เบอร์โทร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_tel"
                  value={formData.ap_tel || ""}
                  onChange={handleChange}
                  maxLength="100"
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">เบอร์โทร 2</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="ap_tel2"
                  value={formData.ap_tel2 || ""}
                  onChange={handleChange}
                  maxLength="100"
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">เครดิต</label>
                <CurrencyInput
                  maxLength={10}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="ap_credit"
                  value={formData.ap_credit || ""}
                  onValueChange={(value, name) =>
                    handleCurrencyChange(value, name)
                  }
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">ภาษีมูลค่าเพิ่ม</label>
                <CurrencyInput
                  maxLength={10}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="ap_vat"
                  value={formData.ap_vat || ""}
                  onValueChange={(value, name) =>
                    handleCurrencyChange(value, name)
                  }
                />
              </div>
              <div className="col-md-3 mt-2">
                <label className="">การลดราคา</label>
                <CurrencyInput
                  maxLength={10}
                  decimalsLimit={2}
                  decimalScale={2}
                  allowNegativeValue={false}
                  className="form-control input-spacing text-end"
                  name="ap_discount"
                  value={formData.ap_discount || ""}
                  onValueChange={(value, name) =>
                    handleCurrencyChange(value, name)
                  }
                />
              </div>
              <div className="col-md-1 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="ap_status"
                  value={formData.ap_status || "Y"}
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
              <div className="col-md-2 mt-2">
                <label className="">ประเภทใบสั่งซื้อ</label>
                <select
                  className="form-select "
                  name="ap_type_s"
                  value={formData.ap_type_s}
                  onChange={handleChange}
                  // disabled={mode === "U"}
                >
                  <option value="M">ต่างประเทศ</option>
                  <option value="L">ภายในประเทศ</option>
                </select>
              </div>
              <div className="col-md-10 mt-2">
                <label className="form-label">Feed back</label>
                <div className="d-flex align-items-center gap-4 flex-wrap">
                  {/* Email Feedback */}
                  <div className="d-flex align-items-center gap-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="fb_email"
                      checked={formData.ap_fb_email !== null}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          ap_fb_email: e.target.checked ? "" : null,
                        }))
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="fb_email"
                      style={{ width: "40px" }}
                    >
                      อีเมล์
                    </label>
                    <input
                      type="email"
                      name="ap_fb_email"
                      className="form-control"
                      style={{ width: "250px" }}
                      placeholder="กรอกอีเมล์สำหรับ Feedback"
                      value={formData.ap_fb_email ?? ""}
                      onChange={handleChange}
                      disabled={formData.ap_fb_email === null}
                    />
                  </div>

                  {/* Phone Feedback */}
                  <div className="d-flex align-items-center gap-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="fb_tel"
                      checked={formData.ap_fb_telephone !== null}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          ap_fb_telephone: e.target.checked ? "" : null,
                        }))
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="fb_tel"
                      style={{ width: "55px" }}
                    >
                      เบอร์โทร
                    </label>
                    <input
                      type="text"
                      name="ap_fb_telephone"
                      className="form-control"
                      style={{ width: "230px" }}
                      placeholder="กรอกเบอร์โทรสำหรับ Feedback"
                      value={formData.ap_fb_telephone ?? ""}
                      onChange={handleChange}
                      disabled={formData.ap_fb_telephone === null}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ overflowY: "auto", maxHeight: "500px" }}>
              <BankTable
                bankList={bankList}
                setBankList={setBankList}
                disabled={false}
              />
            </div>

            <div className="row mt-4">
              {mode !== "I" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/creditor")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleUpdateAP()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
